import React, { useEffect } from 'react'
import styled from 'styled-components'
import { ChatMessage } from '.'
import { Message } from './Message'
import { animateScroll } from 'react-scroll'

interface Props {
  messages?: ChatMessage[]
  className?: string
}
export const ChatMessages: React.FC<Props> = ({ className, messages }) => {
  // Scroll to bottom when new messages are loaded
  const scrollToChatBottom = (duration: number) =>
    animateScroll.scrollToBottom({
      containerId: 'messageWrapper',
      duration: duration, // On first render
    })

  // Scroll to botton on first loading of page
  useEffect(() => scrollToChatBottom(0), []) // 0 animation duration of first render, otherwise it will not react the bottom

  // Scroll to bottom when a new message is added but not yet sent
  useEffect(() => scrollToChatBottom(200), [messages])

  // Scroll to bottom when a new message is effectively sent
  const onMessageSent = () => {
    scrollToChatBottom(200)
  }

  return (
    <ChatMessagesWrapper className={className} id='messageWrapper'>
      {messages &&
        messages.map(message => {
          return (
            <Message
              key={message.id}
              message={message}
              onMessageSent={onMessageSent}
            ></Message>
          )
        })}
    </ChatMessagesWrapper>
  )
}

const ChatMessagesWrapper = styled.div``
